import { render } from "./PurchasePlanetaryPositionsReport.vue?vue&type=template&id=67d02b9c&scoped=true"
import script from "./PurchasePlanetaryPositionsReport.vue?vue&type=script&lang=js"
export * from "./PurchasePlanetaryPositionsReport.vue?vue&type=script&lang=js"

import "./PurchasePlanetaryPositionsReport.vue?vue&type=style&index=0&id=67d02b9c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d02b9c"]])

export default __exports__